import { motion } from "framer-motion";
import { FadeIn } from "@/components/FadeIn";
import { ServiceIcon } from "@/components/ServiceIcon";
import { useLang } from "@/context/LanguageContext";

export const WhyUs = ({ content }) => {
  const { t, tc } = useLang();
  const items = content.why_us || [];
  return (
    <section id="warum-wir" data-testid="whyus-section" className="relative py-24 md:py-32 bg-white overflow-hidden">
      <div className="pointer-events-none absolute -top-40 -right-40 w-[500px] h-[500px] bg-blue-500/10 rounded-full blur-[120px]" />
      <div className="pointer-events-none absolute -bottom-40 -left-40 w-[400px] h-[400px] bg-blue-400/5 rounded-full blur-[100px]" />

      <div className="container-x relative z-10">
        <FadeIn className="max-w-2xl mb-16">
          <span className="overline">{t("why.overline")}</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mt-3 mb-4">{t("why.title")}</h2>
          <p className="text-slate-500 md:text-lg">{t("why.subtitle")}</p>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <motion.div
              key={i}
              data-testid={`whyus-card-${i}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group relative card-light p-8 hover:-translate-y-1.5 overflow-hidden"
            >
              <div className="absolute top-0 left-0 h-1 w-0 bg-blue-600 group-hover:w-full transition-all duration-500" />
              <div className="flex items-start gap-5">
                <div className="shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow-lg shadow-blue-600/30 group-hover:scale-110 transition-transform duration-300">
                  <ServiceIcon name={it.icon} className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-slate-900 mb-1.5">{tc(it.title)}</h3>
                  <p className="text-sm text-slate-500 leading-relaxed">{tc(it.desc)}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
